import { createContext, useContext, useState, ReactNode } from "react";
import { LeadFunnel } from "@/components/site/LeadFunnel";

interface LeadFunnelContextValue {
  open: () => void;
}

const LeadFunnelContext = createContext<LeadFunnelContextValue | null>(null);

export const LeadFunnelProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <LeadFunnelContext.Provider value={{ open: () => setIsOpen(true) }}>
      {children}
      <LeadFunnel open={isOpen} onOpenChange={setIsOpen} />
    </LeadFunnelContext.Provider>
  );
};

export const useLeadFunnel = () => {
  const ctx = useContext(LeadFunnelContext);
  if (!ctx) throw new Error("useLeadFunnel must be used inside LeadFunnelProvider");
  return ctx;
};
